module.exports = __webpack_public_path__ + "img/dice-5.ea58396b.svg";